// 能力概览

import { RootObject, Content ,TextType} from '../../type';
import './style.less';


const AbilityToOverview = (props: RootObject["abilityToOverview"]) => {
  return (
    <div className="AbilityToOverview">
      <div className="title">
        {props.abilityToOverviewTitle ?? ""}
      </div>
      <div className="content_wrapper">

        {
          props.content.map((value: Content, index: number) => {
            return (
              <div className="model" key={index}>
               <div className="model_img">
               <img className="img" src={value.img} alt=""></img>
               </div>
                <div className="model_title">
                  {value.title ?? ""}
                </div>
                <div className="model_describe">
                 {
                   value?.content.map((textValue:TextType,keys:number)=>{
                    return (
                      <div className="model_desc_text" key={keys}>{textValue.text ?? ""}</div>
                    )
                   })
                 }
                </div>
              </div>
            )
          })
        }

      </div>
    </div>
  )
}

export default AbilityToOverview;